import { defineMessages } from "react-intl"
import { CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS, CUSTOM_FIELD_AVAILABLE_FROM, CUSTOM_FIELD_TYPE } from "./constants"

export const CUSTOM_FIELD_AVAILABLE_FROM_MESSAGES = defineMessages({
    [CUSTOM_FIELD_AVAILABLE_FROM.INVOICE]: {
        id: "breadcrumbs.invoices",
        defaultMessage: "Invoices",
    },
    [CUSTOM_FIELD_AVAILABLE_FROM.RETURN]: {
        id: "breadcrumbs.returns",
        defaultMessage: "Returns",
    },
    [CUSTOM_FIELD_AVAILABLE_FROM.QUOTE]: {
        id: "breadcrumbs.quotes",
        defaultMessage: "Quotes",
    },
    [CUSTOM_FIELD_AVAILABLE_FROM.ORDER]: {
        id: "breadcrumbs.orders",
        defaultMessage: "Orders",
    },
    [CUSTOM_FIELD_AVAILABLE_FROM.ORGANIZATIONS]: {
        id: "custom_fields.organizations",
        defaultMessage: "Organizations",
    },
    [CUSTOM_FIELD_AVAILABLE_FROM.PERSON]: {
        id: "custom_fields.persons",
        defaultMessage: "Persons",
    },
    [CUSTOM_FIELD_AVAILABLE_FROM.SUPPLIER]: {
        id: "custom_fields.suppliers",
        defaultMessage: "Suppliers",
    },
    [CUSTOM_FIELD_AVAILABLE_FROM.ALL]: {
        id: "custom_fields.all",
        defaultMessage: "All",
    },
})

export const CUSTOM_FIELD_TYPE_MESSAGES = defineMessages({
    [CUSTOM_FIELD_TYPE.TEXT]: {
        id: "custom_field_definition.form.edit.type_text_label",
        defaultMessage: "Text",
    },
    [CUSTOM_FIELD_TYPE.MULTI_LINE_TEXT]: {
        id: "custom_field_definition.form.edit.type_multi_line_text_label",
        defaultMessage: "Multi line text",
    },
    [CUSTOM_FIELD_TYPE.DATE]: {
        id: "custom_field_definition.form.edit.type_date_label",
        defaultMessage: "Date",
    },
    [CUSTOM_FIELD_TYPE.SINGLE_CHOICE]: {
        id: "custom_field_definition.form.edit.type_single_choice_label",
        defaultMessage: "List of choice",
    },
    [CUSTOM_FIELD_TYPE.IMAGE]: {
        id: "custom_field_definition.form.edit.type_image_label",
        defaultMessage: "Image",
    },
    [CUSTOM_FIELD_TYPE.FILE]: {
        id: "custom_field_definition.form.edit.type_file_label",
        defaultMessage: "File",
    },
})

export const CUSTOM_FIELD_EDIT_MESSAGES = defineMessages({
    "name_placeholder": {
        id: "custom_field_definition.form.edit.name_placeholder",
        defaultMessage: "Name of the custom field",
    },
    "save_btn": {
        id: "custom_field_definition.form.edit.save_btn",
        defaultMessage: "Save custom field",
    },
    "choose-type": {
        id: "custom_field_definition.form.edit.choose_type_label",
        defaultMessage: "Choose",
    },
})


export const CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS_MESSAGES = defineMessages({
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.JPEG]: {
        id: "custom_field_definition.form.edit.jpeg",
        defaultMessage: ".jpeg",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.JPG]: {
        id: "custom_field_definition.form.edit.jpg",
        defaultMessage: ".jpg",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.PNG]: {
        id: "custom_field_definition.form.edit.png",
        defaultMessage: ".png",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.GIF]: {
        id: "custom_field_definition.form.edit.gif",
        defaultMessage: ".gif",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.TIFF]: {
        id: "custom_field_definition.form.edit.tiff",
        defaultMessage: ".tiff",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.WEBP]: {
        id: "custom_field_definition.form.edit.webp",
        defaultMessage: ".webp",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.SVG]: {
        id: "custom_field_definition.form.edit.svg",
        defaultMessage: ".svg",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.PDF]: {
        id: "custom_field_definition.form.edit.pdf",
        defaultMessage: ".pdf",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.AI]: {
        id: "custom_field_definition.form.edit.ai",
        defaultMessage: ".ai",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.PS]: {
        id: "custom_field_definition.form.edit.ps",
        defaultMessage: ".ps",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.EPS]: {
        id: "custom_field_definition.form.edit.eps",
        defaultMessage: ".eps",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.PSD]: {
        id: "custom_field_definition.form.edit.psd",
        defaultMessage: ".psd",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.DOC]: {
        id: "custom_field_definition.form.edit.doc",
        defaultMessage: ".doc",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.DOCX]: {
        id: "custom_field_definition.form.edit.docx",
        defaultMessage: ".docx",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.XLS]: {
        id: "custom_field_definition.form.edit.xls",
        defaultMessage: ".xls",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.XLSX]: {
        id: "custom_field_definition.form.edit.xlsx",
        defaultMessage: ".xlsx",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.PP]: {
        id: "custom_field_definition.form.edit.pp",
        defaultMessage: ".pp",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.PPX]: {
        id: "custom_field_definition.form.edit.ppx",
        defaultMessage: ".ppx",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.RTF]: {
        id: "custom_field_definition.form.edit.rtf",
        defaultMessage: ".rtf",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.TXT]: {
        id: "custom_field_definition.form.edit.txt",
        defaultMessage: ".txt",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.CSV]: {
        id: "custom_field_definition.form.edit.csv",
        defaultMessage: ".csv",
    },
    [CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS.VSD]: {
        id: "custom_field_definition.form.edit.vsd",
        defaultMessage: ".vsd",
    },
})


// WEBPACK FOOTER //
// ./src/utils/customField/messages.ts